import React, { Component } from 'react';
import {Grid,Link, Typography} from "@material-ui/core";
import Navbar from "../NAV/Navbar";
import axios from "axios";

class ViewAllPosts extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            listOfArticles:[],
            seriesNames:[]
         }
    }
    componentDidMount(){
        axios.get("https://know-search-backend.herokuapp.com/getArticleList").then((res)=>{
           this.setState({
               listOfArticles:res.data
           })
        })
        axios.get("https://know-search-backend.herokuapp.com/getAllSeriesNames").then((res)=>{
            console.log(res);
            this.setState({
                seriesNames:res.data
            })
        })
    }
    handleSeriesClick(ele){
        axios.get("https://know-search-backend.herokuapp.com/getArticlesBySeries",{params:{Series:ele}}).then((res)=>{
            console.log(res);
           this.setState({
               listOfArticles:res.data
           })
        })
    }
    render() { 
        return ( 
        <Grid container>
            <Navbar/>
            <Grid item container md={3} xs={3}>
                <Grid item container xs={12} style={{padding:"1vw",margin:"1vw",backgroundColor:"#F0EEEE"}}>
                <Grid item xs={12}>
                    <Typography style={{textAlign:"center",marginBottom:"2vh"}} variant="h4"><b>Series Names</b></Typography>
                {this.state.seriesNames.map((ele)=>{
                    return <Typography noWrap variant="h5" onClick={()=>{this.handleSeriesClick(ele)}}>
                        {ele}
                        </Typography>
                })}
                </Grid>
                </Grid>
            </Grid>
            <Grid item container md={6} xs={8} style={{padding:"2vw"}}>{this.state.listOfArticles.map((ele)=>{
                var date=new Date(parseInt(ele.time));
            var date12=date.toDateString();
                let stringLink="/view:"+ele.time;
                return <Grid item container key={ele.time} xs={12} style={{marginBottom:"0vh",marginTop:"5vh"}}> 
                    <Grid item container xs={12} style={{marginBottom:"2vh"}}>
                        <Grid item xs={1} style={{textAlign:"right"}}>
                            <img style={{borderRadius:"50%",width:"4vw",height:"4vw"}} src={ele.imgUrl}/>
                        </Grid>
                        <Grid xs={11} item style={{paddingLeft:"1vw"}}>
                            <h5>{ele.name} in {ele.Series}</h5>
                            <h6>{date12}</h6>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{marginLeft:"1vw"}}>
                        <Link href={stringLink}>{ele.title}</Link>
                    </Grid>
                    <Grid item xs={12} style={{marginLeft:"1vw"}}>
                        <Typography variant="h5">{ele.openingText}</Typography>
                    </Grid>
                    <hr style={{width:"100%"}}></hr>
                </Grid>
            })}</Grid>
            <Grid item md={3} xs={1}></Grid>
            
            
        </Grid>    
         );
    }
}
 
export default ViewAllPosts;


// WEBPACK FOOTER //
// ./src/components/VIEW/ViewAllPosts.js